import { ERubric } from '../../types/rubricsLinks';

export function navbarDefaultRubricsReducer(state: ERubric[] = []): ERubric[] {
  return state;
}
